///
/// EarthBrowser
///
/// Created by Matt Giger on September 16, 2026
/// Copyright (c) 2026 Geodata Labs
///
/// Stable per-browser device identifier for license seat enforcement.
/// A random UUID generated once and persisted in localStorage — deliberately
/// NOT a fingerprint: it survives browser and OS updates and carries no
/// information about the machine. Migrates any legacy fingerprint hash that
/// was already stored so existing device records keep their identity.
///

const cDeviceIdKey = 'device_id'
const cLegacyFingerprintKey = 'device_fingerprint'

let cachedDeviceId: string | undefined

export function getDeviceId(): string {
	if (cachedDeviceId) {
		return cachedDeviceId
	}

	try {
		const stored = localStorage.getItem(cDeviceIdKey)
		if (stored) {
			cachedDeviceId = stored
			return stored
		}

		// Migrate the legacy fingerprint hash so device records already
		// matched by device_fingerprint server-side keep their identity
		const legacy = localStorage.getItem(cLegacyFingerprintKey)
		const id = legacy || crypto.randomUUID()
		localStorage.setItem(cDeviceIdKey, id)
		cachedDeviceId = id
		return id
	} catch {
		// Storage unavailable: fall back to a per-session id so requests
		// still carry a device identity
		if (!cachedDeviceId) {
			cachedDeviceId = crypto.randomUUID()
		}
		return cachedDeviceId
	}
}
